import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../../../../store/app'
import { useDispatch, useSelector } from 'react-redux'
import { ViewIntersetExam, finishExam, submitAnswer, tierOneSubmitAnswer,  setGoSkillModal, getTrialExam, completeTrialExam } from '../../../WebDashBoard/Components/Utils/slice'
import { useNavigate, useParams } from 'react-router-dom'
import InterestAssessmentForm from './InterestAssessmentCommon/InterestAssessmentForm'
import { Form } from 'antd'
import PageSpinner from '../../../../../components/PageSpinner/PageSpinner'
import dayjs from 'dayjs'
import { setUserOptions } from '../../../../../store/AuthSlice'
import { setShowIntrestPopup } from '../../../../../store/CommonSlice'
import { get_users_industry } from '../../../../../config/Global'

/**
 * Renders the component for pending Interest Discovery Exam.
 *
 * @return {JSX.Element} The rendered component.
 */
const InterestAssessmentPending = () => {
    const dispatch: AppDispatch = useDispatch()
    const { id }: any = useParams()
    const allsteps = useSelector((state: RootState) => state.WEBPROFILE.bothExamData)
    const userDetail = useSelector((state: RootState) => state.AUTH.userDetail)

    const [current, setCurrent] = useState(Number(0));
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [updateSteps, setUpdateSteps] = useState<any>([])
    const [IntersetExamRecords, setIntersetExamRecords] = useState<any>(null);
    const decodedDataId = atob(id);

    const [generalQuestionLimit, setGeneralQuestion] = useState<any>(10);
    const [tierOneLimit, setTierOneLimit] = useState<any>(0);
    const [itemsPerPage, setItemsPerPage] = useState<any>(10);

    const totalQuestionLimit = generalQuestionLimit + tierOneLimit;
    const { is_solar } = get_users_industry(userDetail);



    useEffect(() => {
        dispatch(setUserOptions()).catch((e: any) => e)

        dispatch(getTrialExam(decodedDataId))
            .then((data: any) => {
                // if (data.data.exam_status == 4) {
                //     navigate('/interest-assessment-exam/' + id);
                //     return 0;
                // }
                setIntersetExamRecords(data?.data);

                setLoading(false)



            })
            .catch((e: any) => e)

    }, [])

    // Set the answer of answered questions in the exam and to set remaining questions in the exam
    useEffect(() => {
        if (IntersetExamRecords != null) {

            const steps = IntersetExamRecords?.questions?.map((item: any, index: number) => ({
                key: item?.id,
                title: item?.question,
                content: item?.answers,
                question_id: item?.id,
                options: item?.answer_options,
                index: index + 1,
                disabled: true
            }));
            setUpdateSteps(steps)

        }

    }, [IntersetExamRecords]);



    // const itemsPerPage = 6;
    const startIndex = current;
    const endIndex = current + itemsPerPage;
    const getFirstSix = updateSteps?.length > 0 && updateSteps?.slice(startIndex, endIndex);
    const lastArrayData = getFirstSix && getFirstSix[getFirstSix?.length - 1]
    console.log("getFirstSix", getFirstSix)



    const validateForm = () => {
        form.validateFields()
    };

    // Button to move to next page and fetch remaining questions after 36 questions
    const nextButton = (data: any) => {
         setBtnLoading(true)
        completeExam(data)
    }

    // For scroll to the top after clicking on next button
    useEffect(() => {
        if (!btnLoading) {
            if ((document.body.clientHeight - 4) > window.innerHeight) {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }
        }
    }, [nextButton, btnLoading])

    // For submitting the exam after all the questions are answered
    const completeExam = (data: any) => {
        console.log(data);
        let finalObject: any = { answers: [] };
        for (let item in data) {
            finalObject.answers.push({
                ques_id: item,
                ans_id: data[item],
            });
        }

        dispatch(completeTrialExam(decodedDataId, finalObject))
            .then(() => {
                navigate("/dashboard")
             })
            .catch((e: any) => {
                e
                setBtnLoading(false)
            })

    }

    return !loading && getFirstSix ? (
        <>
            <InterestAssessmentForm
                validateForm={validateForm}
                steps={updateSteps}
                nextButton={nextButton}
                form={form}
                current={current}
                setCurrent={setCurrent}
                id="InterestAssessmentFormPending"
                getFirstSix={getFirstSix}
                lastArrayData={lastArrayData}
                btnLoading={btnLoading}
                generalQuestionsLimit={generalQuestionLimit}
                tier1QuestionsLimit={tierOneLimit}
                industry_id={userDetail?.industry_id}
                itemsPerPage={itemsPerPage}

            />
        </>
    ) : <PageSpinner />
}

export default InterestAssessmentPending